import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { LibraryCollectionViewerComponent } from './library-collection-viewer.component';

// TODO - remove when umcLibrary STAB-776 and libraryCollectionViewer STAB-721
export const ngxLibraryCollectionViewerModule = angular.module('ngxLibraryCollectionViewerModule', [])
	.directive('ngxLibraryCollectionViewer', downgradeComponent({ component: LibraryCollectionViewerComponent }))
	.name;
